import type { ElementDebugSource } from './protocol';

/** Design-system / library paths — skip when resolving JSX persist target so edits land on page call sites. */
export function isDesignSystemFilePath(filePath: string): boolean {
  const n = filePath.replace(/\\/g, '/').toLowerCase();
  if (!n.startsWith('src/')) return true;
  if (n.includes('/node_modules/')) return true;
  if (/\bsrc\/components\/ui\b/.test(n)) return true;
  // Ideoz's own files in a prototype (the mobile kit, brand, bridge, styles): a click on text a kit
  // component draws edits the screen that passed it in, as a shadcn component does on the web.
  if (/\bsrc\/ideoz\//.test(n)) return true;
  if (/__tests__?\//i.test(n)) return true;
  return false;
}

/**
 * Prefer the innermost JSX source walking leaf→root fiber chain that is not under design-system code.
 */
export function pickPersistSource(leafToRoot: ElementDebugSource[]): ElementDebugSource | null {
  for (const s of leafToRoot) {
    if (!isDesignSystemFilePath(s.filePath)) return s;
  }
  return null;
}

export function classifyEditTarget(leafToRoot: ElementDebugSource[]): 'callSite' | 'designSystemOnly' | 'missing' {
  if (leafToRoot.length === 0) return 'missing';
  const p = pickPersistSource(leafToRoot);
  return p ? 'callSite' : 'designSystemOnly';
}
